export const CLOUDINARY_IMAGE_CATEGORIES = ['images', 'logo'];

export const DEFAULT_RATIOS = {
    images: 16 / 9,
    logo: 1,
};